/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    all: [],
}

const RoadmapSlice = createAppSlice({
    name: 'gdl/roadmap',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createSubject: create.asyncThunk(
            async (subject, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.subjects(), { body: subject, method: 'POST' })
                    toast.success('Sujet créé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'un sujet')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        updateSubject: create.asyncThunk(
            async (subject, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.subjects(), { body: subject, method: 'PUT' })
                    toast.success('Sujet modifié avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'un sujet')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        deleteSubject: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.subject(id), { method: 'DELETE' })
                    toast.success('Sujet supprimé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'un sujet')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        fetchSubject: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.subjects())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des sujets')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.all = action.payload
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.all.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            },
        ),
    }),
})

export const { fetchCustomerNotes, updateSubject, createSubject, deleteSubject } = RoadmapSlice.actions

export default RoadmapSlice